<script setup lang="ts">
  import { computed } from 'vue';
  import type { FillTitleProperties, FormElement } from '../../../model/form.types';
  import { useElementContainerStyles } from '../../../model/useElementContainerStyles';
  import { useLabelPosition } from '../../../model/useLabelPosition';

  interface Props {
    element: FormElement & { properties: FillTitleProperties };
  }

  const props = defineProps<Props>();

  const { isLabelLeft, inputClasses, labelClasses, labelStyles } = useLabelPosition(
    computed(() => props.element.properties)
  );

  const { containerStyles } = useElementContainerStyles(
    computed(() => props.element.properties),
    'FILL_TITLE'
  );

  const placeholderText = computed(() => props.element.properties.auxiliaryText);

  const labelStyle = computed(() => ({
    color: props.element.properties.color ?? '#2f2f2f',
  }));

  const logFieldNameAttr = computed(() => props.element.properties.logFieldName ?? undefined);
</script>

<template>
  <div
    class="fill-title-element font-base w-full min-w-0 max-w-full box-border"
    :class="{ 'label-left flex items-center': isLabelLeft }"
    :style="containerStyles"
  >
    <label
      :for="`input-${element.id}`"
      :class="[labelClasses, { 'shrink-0 whitespace-nowrap': isLabelLeft }]"
      :style="[labelStyles, labelStyle]"
    >
      {{ element.properties.label }}
    </label>
    <input
      :id="`input-${element.id}`"
      type="text"
      :name="element.properties.name"
      value=""
      :placeholder="placeholderText"
      :aria-label="element.properties.label || element.properties.name"
      readonly
      :class="[
        inputClasses,
        'text-[11px] leading-4 placeholder:text-[10px] placeholder:opacity-60',
        { 'flex-1 min-w-0 max-w-full w-0': isLabelLeft },
      ]"
      :data-log-field-name="logFieldNameAttr"
    >
  </div>
</template>
